export const SET_DEFAULT_HARDWARE_PAYMENTS = 'SET_DEFAULT_HARDWARE_PAYMENTS';

export const GET_HARDWARE_PAYMENTS_REQUEST = 'GET_HARDWARE_PAYMENTS_REQUEST';
export const GET_HARDWARE_PAYMENTS_SUCCESS = 'GET_HARDWARE_PAYMENTS_SUCCESS';
export const GET_HARDWARE_PAYMENTS_FAILURE = 'GET_HARDWARE_PAYMENTS_FAILURE';

export const GET_HARDWARE_TOTALS_REQUEST = 'GET_HARDWARE_TOTALS_REQUEST';
export const GET_HARDWARE_TOTALS_SUCCESS = 'GET_HARDWARE_TOTALS_SUCCESS';
export const GET_HARDWARE_TOTALS_FAILURE = 'GET_HARDWARE_TOTALS_FAILURE';

export const GET_RATES_REQUEST = 'GET_RATES_REQUEST';
export const GET_RATES_SUCCESS = 'GET_RATES_SUCCESS';
export const GET_RATES_FAILURE = 'GET_RATES_FAILURE';

export const UPDATE_HARDWARE_PAYMENT_STATUS_REQUEST = 'UPDATE_HARDWARE_PAYMENT_STATUS_REQUEST';
export const UPDATE_HARDWARE_PAYMENT_STATUS_SUCCESS = 'UPDATE_HARDWARE_PAYMENT_STATUS_SUCCESS';
export const UPDATE_HARDWARE_PAYMENT_STATUS_FAILURE = 'UPDATE_HARDWARE_PAYMENT_STATUS_FAILURE';

export const UPDATE_HARDWARE_PAYMENT_DATA_REQUEST = 'UPDATE_HARDWARE_PAYMENT_DATA_REQUEST';
export const UPDATE_HARDWARE_PAYMENT_DATA_SUCCESS = 'UPDATE_HARDWARE_PAYMENT_DATA_SUCCESS';
export const UPDATE_HARDWARE_PAYMENT_DATA_FAILURE = 'UPDATE_HARDWARE_PAYMENT_DATA_FAILURE';
